import React from 'react';
import { motion } from 'framer-motion';
export function Proof() {
  return <section className="py-16 md:py-24 px-5 bg-[#5C1A2B] text-[#FAF5EE]" data-id="element-152">
      <div className="max-w-2xl mx-auto text-center" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative px-4" data-id="element-154">
          <span className="absolute -top-6 -left-2 text-6xl md:text-8xl font-serif text-[#C86B5E] opacity-40" data-id="element-155">
            "
          </span>
          <p className="font-serif italic text-xl md:text-3xl leading-relaxed relative z-10" data-id="element-156">
            Lo que vas a sentir no es magia, es{' '}
            <span className="not-italic font-semibold tracking-wide text-[#C86B5E]" data-id="element-157">
              ALIVIO
            </span>
            . En 7 días vuelves a comer, vuelves a dormir, y dejas de mirar el
            celular esperando que sea él.
          </p>
          <span className="absolute -bottom-12 -right-2 text-6xl md:text-8xl font-serif text-[#C86B5E] opacity-40" data-id="element-158">
            "
          </span>
        </motion.div>
      </div>
    </section>;
}